module.exports = __webpack_public_path__ + "static/distribution4-97faa02b84a134325b082b9bba66bcf9.jpg";